import { gql } from "@apollo/client";

export const CREATE_PROFESIONALES = gql`
    mutation CreateProfesionalRI(
        $idDatosGeneralesRI: Int!
        $input: AddProfesionalRIInput!)
    {
        createProfesionalRI(
            idDatosGeneralesRI: $idDatosGeneralesRI
            input: $input
        ){
            profesionalRI{
                idProfesionalRI
            }
            profesionalEspecialidadRI{
                idProfesionalEspecialidadRI
            }
        }
    }
`;